import { Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IPaymentsBasketView } from './paywith/basket-view-paywith.component';
import { NCmsTrustpilotWidget } from '../../cms/trustpilot-widget/cms-trustpilot-widget.component';
import { BasketViewComponent } from './basket-view.component';

export namespace NBasketViewCms {
    export const BLOCK_ID = 'cms-basket-view';

    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;

    export interface IBlockDataContent extends NCmsTrustpilotWidget.IData {
        sideImage?: string;
        sideImageRatio?: string;
        sideCopy?: string;
        bottomComponents: NICmsContentComponent.IData[];
        emptyComponents: NICmsContentComponent.IData[];
        emptyCopy: string;
        emptyCtaCopy: string;
        payments?: IPaymentsBasketView[];
        basketCustomerInfo?: string;
        copyBasketLink?: string;
    }
}

/**
 * Component definition
 */
@Component({
    selector: 'basket-view-cms',
    template: '@if (content) {<basket-view [content]="content"></basket-view>}',
    standalone: true,
    imports: [BasketViewComponent]
})
@ICmsComponent<BasketViewCmsComponent>({
    id: NBasketViewCms.BLOCK_ID,
    block: {
        url: NBasketViewCms.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Basket page layout',
    description: 'Basket page layout block',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-specification',
            title: 'Side area'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'sideImage',
            title: 'Side image'
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'sideImageRatio',
            title: 'Side image ratio',
            options: RatioOptions
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'sideCopy',
            title: 'Side copy'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-bottom',
            title: 'Bottom part'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'payments',
            title: 'Payments',
            itemName: 'Payment Option',
            itemNameField: 'name',
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'name',
                    title: 'Payment name'
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'icon',
                    title: 'Payment icon'
                }
            ]
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-empty',
            title: 'Empty basket'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'emptyCopy',
            title: 'Empty basket heading copy',
            default: 'Your bag is empty',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'emptyCtaCopy',
            title: 'Empty basket continue button copy',
            default: 'Continue shopping',
            required: true
        },
        <NICmsContentField.IComponentsField>{
            key: 'emptyComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Empty basket components',
            itemName: 'component',
            default: []
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'basketCustomerInfo',
            title: 'Customer basket information'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'copyBasketLink',
            title: 'Copy Basket Link title',
            default: 'Copy Basket Link'
        },
        ...NCmsTrustpilotWidget.getFields(['reviewLanguages', 'stars'])
    ]
})
export class BasketViewCmsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NBasketViewCms.IBlockDataContent;

    protected override canDetach = false;
}
